/* eslint-disable */
import * as Types from '../../../../../types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions = {} as const;
export type InProductMessagesQueryVariables = Types.Exact<{
  input: Types.InProductMessagesInput;
}>;

export type InProductMessagesQuery = {
  __typename?: 'Query';
  inProductMessages: {
    __typename?: 'InProductMessagesList';
    items: Array<{
      __typename?: 'InProductMessage';
      content: string;
      sentAt: any;
      id: string;
      isRead: boolean;
    }>;
    cursorInfo: {
      __typename?: 'InProductMessagesCursorInfo';
      lastMessageId?: string | null;
    };
  };
};

export const InProductMessagesDocument = gql`
  query inProductMessages($input: InProductMessagesInput!) {
    inProductMessages(input: $input) {
      items {
        content
        sentAt
        id
        isRead
      }
      cursorInfo {
        lastMessageId
      }
    }
  }
`;

/**
 * __useInProductMessagesQuery__
 *
 * To run a query within a React component, call `useInProductMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProductMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProductMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInProductMessagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >(InProductMessagesDocument, options);
}
export function useInProductMessagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >(InProductMessagesDocument, options);
}
export type InProductMessagesQueryHookResult = ReturnType<
  typeof useInProductMessagesQuery
>;
export type InProductMessagesLazyQueryHookResult = ReturnType<
  typeof useInProductMessagesLazyQuery
>;
export type InProductMessagesQueryResult = ApolloReactCommon.QueryResult<
  InProductMessagesQuery,
  InProductMessagesQueryVariables
>;
